// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertInfo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9,18 C12.2153907,18 15.1865337,16.2846093 16.7942294,13.5 C18.4019241,10.7153907 18.4019241,7.28460985 16.7942294,4.5 C15.1865337,1.71539068 12.2153907,0 9,0 C5.78461008,0 2.81346653,1.71539068 1.20577137,4.5 C-0.401923791,7.28460985 -0.401923791,10.7153907 1.20577137,13.5 C2.81346653,16.2846093 5.78461008,18 9,18 Z M7.5937504,11.8125 L8.4375004,11.8125 L8.4375004,9.5625 L7.5937504,9.5625 L6.7500004,9.5625 L6.7500004,7.875 L7.5937504,7.875 L9.2812504,7.875 L10.1250004,7.875 L10.1250004,8.71875 L10.1250004,11.8125 L10.4062504,11.8125 L11.2500004,11.8125 L11.2500004,13.5 L10.4062504,13.5 L7.5937504,13.5 L6.7500004,13.5 L6.7500004,11.8125 L7.5937504,11.8125 Z M10.1250004,6.75 L7.8750004,6.75 L7.8750004,4.5 L10.1250004,4.5 L10.1250004,6.75 Z"
            />
        </svg>
    );
};

export default React.memo(AlertInfo);
